import React from 'react';
import { Button } from '../ui/button';
import { bunnyHeroData } from '../../bunnyMock';
import { Sparkles, TrendingUp } from 'lucide-react';

const BunnyHeroSection = () => {
  return (
    <section className="bunny-hero-gradient min-h-[90vh] flex items-center justify-center relative overflow-hidden">
      {/* Grid pattern overlay */}
      <div className="absolute inset-0 bunny-grid-bg opacity-20"></div>
      
      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-pink-400/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-72 h-72 bg-yellow-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="text-center max-w-5xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md px-5 py-3 rounded-full mb-10 border border-pink-400/30">
            <TrendingUp className="w-5 h-5 bunny-accent-pink" />
            <span className="text-sm font-sans font-bold text-white tracking-widest">FASHION MEETS FUNCTION</span>
          </div>

          {/* Main headline */}
          <h1 className="text-6xl sm:text-7xl lg:text-8xl font-serif bunny-headline text-white mb-8 leading-none">
            {bunnyHeroData.headline.split(' ')[0]} <span className="bunny-accent-pink">{bunnyHeroData.headline.split(' ')[1]}</span> {bunnyHeroData.headline.split(' ')[2]}
          </h1>

          {/* Subheadline */}
          <p className="text-xl sm:text-2xl text-gray-300 font-sans max-w-3xl mx-auto mb-12 leading-relaxed">
            {bunnyHeroData.subheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <button className="bunny-btn-primary px-10 py-4 font-sans">
              {bunnyHeroData.cta}
            </button>
            <button className="bunny-btn-secondary bg-white px-10 py-4 font-sans">
              View Lookbook
            </button>
          </div>

          {/* Trust indicators */}
          <div className="mt-20 flex flex-wrap justify-center items-center gap-12 text-white text-sm font-sans font-bold tracking-wider">
            <div className="flex flex-col items-center">
              <span className="text-3xl bunny-accent-pink mb-2">10K+</span>
              <span className="text-gray-400">Fashion Lovers</span>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600"></div>
            <div className="flex flex-col items-center">
              <span className="text-3xl bunny-accent-pink mb-2">★★★★★</span>
              <span className="text-gray-400">Rated Pieces</span>
            </div>
            <div className="hidden sm:block w-px h-12 bg-gray-600"></div>
            <div className="flex flex-col items-center">
              <span className="text-3xl bunny-accent-pink mb-2">NEW</span>
              <span className="text-gray-400">Drops Weekly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BunnyHeroSection;
